// extracted by mini-css-extract-plugin
export default {"hiddenScrollbar":"CategoryFilters_hiddenScrollbar__hV95x"};